
export default class Event {
    constructor(public type: string) {}

    toObject(): any {
        return Object.assign({}, this);
    }
}